import React, { Component } from "react";
import { connect } from 'react-redux';
import Radium from "radium";
import Utils from "../../../lib/utils";
import avatar from "../../../images/user-img.png";
import { styles, DropdownStyle } from "./style.ts";
import EmployerNav from "./Nav"

const DropdownButton = (user) => (
  <DropdownStyle>
    {user && user.fname} {user && user.lname}
    <span className="hidden-xs">
      <img alt="avatar" style={styles.avatar} src={avatar} />
    </span>
  </DropdownStyle>
);

const EmployerHeader = ({ logout, history, user, pending }) => {
  const logOut = () => logout(history);

  const isGuest = () => !user;

  const show = () => Utils.isSignedIn() || isGuest();

  return (
    !pending && (
      <EmployerNav
        DropdownButton={DropdownButton}
        user={user}
        logOut={logOut}
      />
    )
  );
};

const mapStateToProps = (state) => ({
  user: state.userByToken.user,
  pending: state.userByToken.pending,
});

export default connect(mapStateToProps)(Radium(EmployerHeader));
